import { Catalog } from "../../../types";
import { clientesConfig } from "../../../utils/config";

// Fetch the canonical RBAC catalog directly from clientes-backend's PUBLIC /catalog.
// The catalog is public (no auth) and clientes-backend is not reachable from the gestor
// VPC, so this is a direct browser call rather than a gestor-backend proxy hop.
export const getCatalog = async (): Promise<Catalog> => {
  const base = clientesConfig.clientesApi.replace(/\/+$/, "");
  const response = await fetch(`${base}/catalog`);
  if (!response.ok) {
    throw new Error(`Failed to load catalog: ${response.status}`);
  }
  return response.json();
};

// Every role-grantable key (not public, not baseline) on the given screens — the same
// set the role editor offers for an ops with those screens enabled.
export const grantableKeysForScreens = (
  catalog: Catalog,
  screens: string[]
): string[] => {
  const grantable = new Set(
    catalog.permissions.filter((p) => !p.public && !p.baseline).map((p) => p.key)
  );
  const enabled = new Set(screens);
  const keys = catalog.screens
    .filter((s) => enabled.has(s.screen))
    .flatMap((s) => [...(s.requires || []), ...(s.actions || [])])
    .filter((k) => grantable.has(k));
  return Array.from(new Set(keys));
};
